import { render, staticRenderFns } from "./SchoolSelectAllPage.vue?vue&type=template&id=84ac24f4"
import script from "./SchoolSelectAllPage.vue?vue&type=script&lang=js"
export * from "./SchoolSelectAllPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports